// extracted by mini-css-extract-plugin
export default {"cls1":"News-cls1_SZ9","cls2":"News-cls2__s1 News-cls1_SZ9"};